module.exports = __webpack_public_path__ + "static/media/8OLA3.1c1d3f2b.jpg";